import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type IntlService from 'ember-intl/services/intl';

interface AditoolsCardPartNumberArgs {
  Element: HTMLButtonElement;
  Args: {
    deviceName: string;
    qaName?: string;
    tooltip?: string;
    annotation?: string;
    clicked?: (event: MouseEvent) => void;
    hoverIn?: (event: MouseEvent) => void;
    hoverOut?: (event: MouseEvent) => void;
  };
  Blocks: {
    default: [() => void];
  };
}

export default class AditoolsCardPartNumber extends Component<AditoolsCardPartNumberArgs> {
  @service declare intl: IntlService;

  @tracked partSelectionEnabled = false;

  get qaName() {
    return this.args.qaName ?? 'unnamed';
  }

  get _tooltip() {
    return this.args.tooltip ?? this.intl.t('ember-aditools-page.card.part-number-tooltip');
  }

  @action handleClick(event: MouseEvent) {
    this.partSelectionEnabled = true;
    if (this.args.clicked) {
      this.args.clicked(event);
    }
  }
  @action partSelectionClosed() {
    this.partSelectionEnabled = false;
  }
  @action handleHoverIn(event: MouseEvent) {
    if (this.args.hoverIn) {
      this.args.hoverIn(event);
    }
  }
  @action handleHoverOut(event: MouseEvent) {
    if (this.args.hoverOut) {
      this.args.hoverOut(event);
    }
  }
}
